<template>
  <div class="container title-container">
    <div class="row">
      <span class="title-box">
        <h1 class="title">{{ title }}</h1>
      </span>
      <span class="message-background">
        <h2 class="message">{{ message }}</h2>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Title',
  props: [
    'title',
    'message'
  ]
}
</script>

<style scoped>
.title-container {
  margin-top: 45px;
}
.title-box {
  display: inline-flex;
}
.row {
  flex-direction: column;
}
.title {
  top: 106px;
  left: 64px;
  font-size: 76px;
  font-weight: 700;
  letter-spacing: 0;
  border-bottom: solid;
  color: #0A0909;
  opacity: 1;
}
.message-background {
  background: #333333 0% 0% no-repeat padding-box;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 14.5px;
  padding-right: 14.5px;
}
@media screen and (max-width:600px) {
  .message-background {
    background: #333333 0% 0% no-repeat padding-box;
    padding-top: 7px;
    padding-bottom: 7px;
    padding-left: 14.5px;
    padding-right: 14.5px;
    position: absolute;
    bottom: 40px;
    margin: 20px;
  }
  .title {
    top: 106px;
    left: 64px;
    font-size: 76px;
    font-weight: 700;
    letter-spacing: 0;
    border-bottom: solid;
    color: #0A0909;
    opacity: 1;
    position: absolute;
    top: 45px;
    left: 20px;
  }
}
.message {
  font-size: 45px;
  margin-bottom: 0px;
}
@media screen and (max-width: 480px) {
  .message {
    font-size: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Title.vue